<template>
  <div id="amenity-modal" class="embinfobox elem-modal basic" ref="baseElement">
    <div aria-label="card" class="map-card">
      <i aria-label="close icon" class="emb_closeicon"></i>
      <div class="emb-card_body">
        <div class="mb-10">
          <h3 class="ammenity-title" v-if="amenityTitle">
            {{ amenityTitle }}
          </h3>
          <p class="ammenity-site-address">Community feature</p>
        </div>
        <div>
          <div class="tab" v-if="!!amenityInfo.length &&
            !amenityInfo.every((info) => !info.image_url)
          ">
            <div class="tab-slider">
              <Carousel ref="slick" v-bind="sliderOptions">
                <Slide v-for="amenityInfoImage in amenityInfo" :key="amenityInfoImage.seq_position">
                  <div>
                    <LazyImage :src="addScaler(amenityInfoImage.image_url)" :alt="amenityInfoImage.caption"
                      :isNeighborhoodImage="false" />
                    <h4 class="ammenity-imginfo" v-if="amenityInfoImage.caption">
                      {{ amenityInfoImage.caption }}
                    </h4>
                  </div>
                </Slide>
                <template #addons>
                  <div class="carousel-navigation" v-if="amenityInfo.length > 1">
                      <Navigation />
                    </div>
                </template>
              </Carousel>
            </div>
          </div>
          <div class="content-bottom" v-else-if="amenityCaption">
            {{ amenityCaption }}
          </div>
        </div>

        <div v-if="uniqueAmenity?.length > 1" class="ammenity-next">
          <span @click="loadNewAmenity()">
            Next feature:
            <span class="ammenity-next-link">
              {{ nextAmenityName }}
              <i class="ammenity-next-icon">
                <LeftArrowIcon class="rotate-180" />
              </i>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, defineProps, toRefs } from "vue";
import LazyImage from "./../LazyImage.vue";
import LeftArrowIcon from "@/assets/icons/LeftArrow.vue";
import { AmenityInfo, Amenity } from "./../../types";
import { addImageScaler } from "./../../core";
import { Carousel, Navigation, Slide } from "vue3-carousel";


const props = defineProps<{
  amenityInfo: AmenityInfo[];
  amenityId: string;
  uniqueAmenity: string[];
  isKioskMode: boolean;
  amenities: Amenity[];
  loadNewAmenity: () => void;
}>();


const {
  amenityInfo,
  amenityId,
  uniqueAmenity,
  isKioskMode,
  amenities,
  loadNewAmenity,
} = toRefs(props);



const sliderOptions = ref({ itemsToShow: 1 });
const amenityTitle = ref("");
const amenityCaption = ref("");
const nextAmenityName = ref("");

function setNextAmenityName() {
  let currentIndex = uniqueAmenity.value.indexOf(amenityId.value);
  const nextIndex = (currentIndex + 1) % uniqueAmenity.value.length;
  const uniqueAmenityId = uniqueAmenity.value[nextIndex];
  const nextAminity = amenities.value.find((x) => x.id === uniqueAmenityId);
  nextAmenityName.value = nextAminity ? nextAminity.title : "";
}

function setAmenityTitleAndCaption() {
  for (const info of amenityInfo.value) {
    if (!amenityTitle.value && info.title) amenityTitle.value = info.title;
    if (!amenityCaption.value && info.caption) amenityCaption.value = info.caption;
  }
}

function addScaler(url: string) {
  return addImageScaler(url);
}

onMounted(() => {
  setAmenityTitleAndCaption();
  setNextAmenityName();
});
</script>

<style lang="scss" scoped>
.elem-modal {
  .ammenity {
    &-title {
      @include font(16px, 700);
      color: $primary;
      line-height: 16px;
      margin-bottom: 6px;
      width: calc(100% - var(--dsize, 25px));
      text-transform: capitalize;
    }

    &-site-address {
      @include font(10px, 600);
      line-height: 14px;
      color: $gray-900;
    }

    &-imginfo {
      color: $gray-600;
      @include font(14px, 500);
      margin-top: 10px;
    }

    &-next {
      @include font(9px, 600);
      line-height: 14px;
      text-align: right;
      color: $lime-green-new;
      position: relative;

      &-link {
        text-decoration: underline;
        margin-left: 3px;
        cursor: pointer;
        font-size: 12px;
      }

      &-icon {
        display: inline-block;
        vertical-align: -1px;

        svg {
          height: 10px;
        }
      }
    }
  }
}

.tab-slider img {
  cursor: default;
}
</style>